import React, { forwardRef, useEffect, useImperativeHandle, useState, useRef } from 'react';

function AudioPlayer({ audioUrl, setIsPlayingAudio }, ref) {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio(audioUrl));

  useEffect(() => {
    const currentAudioRef = audioRef.current;
    if (isPlaying) {
      try {
        currentAudioRef
          .play()
          .then(() => console.log('audio player'))
          .catch(err => {
            console.error('Error handling - AudioPlayer:', err);
            setIsPlayingAudio(false);
            setIsPlaying(false);
          });
      } catch (error) {
        console.error('Error Player:', error);
        setIsPlayingAudio(false);
        setIsPlaying(false);
      }
    } else {
      currentAudioRef.pause();
      setIsPlayingAudio(false);
    }

    return () => {
      currentAudioRef.pause();
      currentAudioRef.addEventListener('ended', ev => {
        setIsPlaying(false);
        setIsPlayingAudio(false);
      });
    };
    //eslint-disable-next-line
  }, [isPlaying]);

  const onPlayAndPauseHandler = () => {
    setIsPlaying(prev => !prev);
    setIsPlayingAudio(!isPlaying);
  };

  //eslint-disable-next-line
  useImperativeHandle(ref, () => ({ onPlayAndPauseHandler, isPlaying: () => isPlaying }), []);

  return <div></div>;
}

export default forwardRef(AudioPlayer);
